import { AreaFieldRenderer, AutocompleteFieldRenderer, InputFieldRenderer, SelectFieldRenderer } from '../reduxFields';
import createLocalizedField from './LocalizedFields';

export const LocalizedInputField = createLocalizedField(InputFieldRenderer);
export const LocalizedTextAreaField = createLocalizedField(AreaFieldRenderer);
export const LocalizedSelectField = createLocalizedField(SelectFieldRenderer);
export const LocalizedAutocompleteField = createLocalizedField(AutocompleteFieldRenderer);
